module.exports = __webpack_public_path__ + "img/us2-compressor.ba132eae.jpg";